import React from 'react';
import { useState, useEffect } from 'react';
import { Button } from 'antd';
import { useParams } from 'react-router-dom';
import close from '../images/close.svg';
import VacancyEditor from '../Components/VacancyEditor';
import usePortalService from '../services/PortalService';
import { Vacancy } from './Vacancy';
import { ManagerNavbar } from '../Components/Navbars';
import { Company, Vacancy as VacancyType } from '../types';

let vacancyId: string;
export const CreateVacancyPage = () => {
    const {commonInformation, getVacancyById} = usePortalService();

    const params = useParams();
    vacancyId = params.id as string;

    const [isPreview, setIsPreview] = useState(false)
    const [vacancy, setVacancy] = useState<VacancyType>()
    const [company, setCompany] = useState<Company>()
    
    useEffect(() => {
        if (vacancyId) {
            getVacancyById(vacancyId)  
            .then(result => {
                setVacancy(result.vacancy)
            });
        } 
        commonInformation().then(result => {
            setCompany(result.company)
        });
    }, []);

    if (isPreview) {
        return (
            <>
                <div className="preview-header">
                    <h2> Предпросмотр вакансии </h2>
                    <img src={close} width="20px" style={{cursor:'pointer'}} onClick={() => setIsPreview(false)}/>
                </div>
                <Vacancy vacancy={vacancy as VacancyType} userRole={"student"}>
                    {(vacancy && vacancy.status !== "В архиве" ) && <Button type="primary" style={{width:'173px', marginBottom:'32px'}}> Откликнуться </Button>}
                </Vacancy>
            </>
        )
    } else {
        return (
            <>
                <ManagerNavbar />
                <VacancyEditor 
                    vacancy={vacancy as VacancyType} 
                    company={company as Company} 
                    vacancyId={vacancyId} 
                    setVacancy={setVacancy} 
                    showPreview={setIsPreview}
                />
            </>
        )
    }
};